import logo from './jackboys_logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>ASTROWORLD</h1>
        <p>
          <i>For this life I cannot change...</i>
        </p>
      </header>
    </div>
  );
}

export default App;
